export const LABEL = "SPEICHERN";